import React from 'react'
import { useNavigate, useSearchParams } from 'react-router-dom'
import Container from '@mui/material/Container'

import { useCommand } from '~/client/hooks/cqrpc'
import { useCurrentUser } from '~/client/hooks/auth'
import FullPageLoading from '~/client/components/FullPageLoading'
import ErrorMessage from '~/client/components/ErrorMessage'

export default function EmailVerificationPage() {
  const navigate = useNavigate()
  const { mutate } = useCurrentUser()
  const [ searchParams ] = useSearchParams()
  const token = searchParams.get('token')
  const command = useCommand('users.verifyEmail', {
    onMount(){
      command.call({ token })
    },
    onSuccess({ returnTo, currentUser }){
      mutate(currentUser)
      navigate(returnTo || '/')
    }
  })
  if (command.error) return (
    <Container maxWidth="sm" sx={{p: 2}}>
      <ErrorMessage error={command.error}/>
    </Container>
  )
  return <FullPageLoading />
}
